<div fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">

    <!-----------boton finalizar paso---------->
    <div fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">
        <enc3></enc3>
    </div>
</div>

<!-- <fuse-demo-content></fuse-demo-content> -->